import { ValidatorFn, Validators } from '@angular/forms';
import { luhnValidator } from './luhnValidator';

export const ssnValidator : ValidatorFn[] = [Validators.required, Validators.minLength(10), luhnValidator]